import axios from 'axios'
import { translatePage } from '../utils'

const API = {
    baseUrl: process.env.GATSBY_AWS_ENDPOINT
}

const createSession = ({ persone, businessName, street, number,
    cap, city, province, partitaIva, fiscalCode, codiceFatturazione, email, pec, iva, locale = 'it' }) => {

    const request = {
        people: persone,
        billing: {
            businessName,
            street,
            number,
            cap,
            city,
            province,
            partitaIva,
            fiscalCode,
            codiceFatturazione,
            pec,
            email,
            iva,
            locale
        },
        locale,
        success_url: `${window.location.protocol}//${window.location.host}${translatePage('/grazie-dell-acquisto/', locale)}`,
        cancel_url: window.location.href
    }
    return axios.post(`${API.baseUrl}/stripe-iid/createsession`, request).then(response => response.data.session);
}

const createSessionReport = ({name, surname, tipo, email, fiscalCode, street, number, cap, city,
    province, partitaIva, businessName, codiceFatturazione, pec, companyEmail, iva, newsletter, locale = 'it'}) => {
        
    const formData = { name, surname, tipo, email, fiscalCode, street, number, cap, city,
        province, partitaIva, businessName, codiceFatturazione, pec, companyEmail, iva, newsletter, locale};

    const request = {
        formData,
        success_url: `${window.location.protocol}//${window.location.host}${translatePage('/grazie-dell-acquisto-report/', locale)}?source=stripe`,
        cancel_url: window.location.href
    }
    return axios.post(`${API.baseUrl}/stripe-iid/createsessionreport`, request).then(response => response.data.session);
}

const sendEmails = ({ persone, businessName, street, number,
    cap, city, province, partitaIva, fiscalCode, codiceFatturazione, email, pec, iva, locale }) => {

    const request = {
        people: persone,
        billing: {
            businessName,
            street,
            number,
            cap,
            city,
            province,
            partitaIva,
            fiscalCode,
            codiceFatturazione,
            pec,
            email,
            iva
        },
        locale
    }
    return axios.post(`${API.baseUrl}/mail-iid/bonifico`, request);
}

const sendReportEmails = ({name, surname, tipo, email, fiscalCode, street, number, cap, city,
    province, partitaIva, businessName, codiceFatturazione, pec, companyEmail, iva, newsletter, locale}) => {

    const formData = { name, surname, tipo, email, fiscalCode, street, number, cap, city,
        province, partitaIva, businessName, codiceFatturazione, pec, companyEmail, iva, newsletter, locale};

    const request = formData;
    return axios.post(`${API.baseUrl}/mail-iid/report-bonifico`, request);
}

const submitNewsletter = email => {
    const request = {
        email
    }
    return axios.post(`${API.baseUrl}/mail-iid/newsletter`, request);
}

export {
    createSession,
    createSessionReport,
    sendEmails,
    sendReportEmails,
    submitNewsletter
}